import { createFileRoute } from '@tanstack/react-router'

import { analyzerInsightsRoomsSearchSchema } from '@/pages/analyzer-insights/rooms-search'

export const Route = createFileRoute('/_layout/analyzer-insights/rooms')({
  validateSearch: analyzerInsightsRoomsSearchSchema,
})
